import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { endCalendarFormPerfDatapoint } from '../actions/perfDatapointActions';

export interface CalendarFormPerfHelperProps {
    formId: string;
}

// Helper component to end form loading perf datapoints on mount
//
// Using a component instead of a hook so that useEffect is triggered after
// any potential early returns in the parent component
const CalendarFormPerfHelper: React.FunctionComponent<CalendarFormPerfHelperProps> = props => {
    const { formId } = props;

    React.useEffect(() => {
        endCalendarFormPerfDatapoint(formId);
    }, []);
    return null;
};

export default observer(CalendarFormPerfHelper);
